export function extractEnglishWords(text: string) {
    return [...text.matchAll(/\p{Script=Latin}+/gu)].map((match) => match[0]);
}
